module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mini-calculator-page', [_c('div', {
    attrs: {
      "slot": "summary-panel"
    },
    slot: "summary-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results a-form-inputs u-full-width u-margin-auto"
  }, [_c('mini-calculator-header', {
    attrs: {
      "title": "Dependency Multiplicand",
      "icon": "dependency-multiplicand"
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "for": "deceased_income",
      "label": "Deceased Net income",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.deceasedNetIncome),
      expression: "deceasedNetIncome",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control:deceased_income.required",
      value: ({
        type: 'number',
        min: 0
      }),
      expression: "{type:'number', min: 0}",
      arg: "deceased_income",
      modifiers: {
        "required": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    ref: "deceasedNetIncome",
    attrs: {
      "autocomplete": "off",
      "name": "deceased_income",
      "id": "deceasedIncome",
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.deceasedNetIncome)
    },
    on: {
      "focus": function($event) {
        _vm.deceasedNetIncome = _vm.deceasedNetIncome || ''
      },
      "blur": [function($event) {
        _vm.deceasedNetIncome = _vm.deceasedNetIncome || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deceasedNetIncome = _vm._n($event.target.value)
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('deceased_income')
    }
  }, [_vm._v("\n                    The Deceased Net income is required and must be a valid amount\n                ")])], 1), _vm._v(" "), _vm._l((_vm.getValue('dependants')), function(item, index) {
    return _c('dependant-income', {
      ref: 'dependentIncome' + index,
      refInFor: true,
      attrs: {
        "reference": 'dependentIncome' + index,
        "showAddButton": true,
        "columnTwo": true,
        "index": index
      },
      on: {
        "deleteDependant": function($event) {
          return _vm.removeDependant(index)
        },
        "addNewDependant": _vm.addDependant
      }
    })
  }), _vm._v(" "), _c('label', [_vm._v("\n                Multiplicand\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "p-dependency-calc__slider"
  }, [_c('vue-slider', {
    ref: "slider",
    attrs: {
      "min": 1,
      "max": 100,
      "real-time": true,
      "clickable": true,
      "piecewise": true,
      "process-style": {
        'backgroundColor': '#4A89E5'
      },
      "tooltip-style": {
        'backgroundColor': '#4A89E5',
        'borderColor': '#4A89E5'
      },
      "formatter": _vm.vueSliderFormatter,
      "label-style": {
        'color': '#fff'
      }
    },
    model: {
      value: (_vm.multiplicand),
      callback: function($$v) {
        _vm.multiplicand = $$v
      },
      expression: "multiplicand"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.resetMultiplicand
    }
  }, [_vm._v("\n                Reset Multiplicand\n            ")]), _vm._v(" "), _c('h2', [_vm._v("Result")]), _vm._v(" "), _c('control', {
    attrs: {
      "before-after": "pound-on-dark",
      "label": "Dependency Multiplicand"
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "disabled": "",
      "name": "deceased_income",
      "type": "text"
    },
    domProps: {
      "value": _vm.currencyFormat(_vm.total)
    }
  })])], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.total > 0),
      expression: "total > 0"
    }],
    attrs: {
      "slot": "results-panel"
    },
    slot: "results-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results-panel u-full-width u-margin-auto"
  }, [_c('h2', [_vm._v("\n                Explanation\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                The dependency multiplicand has been calculated as " + _vm._s(_vm.currencyFormat(_vm.getValue('total'))) + " based on the following:\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                The deceased was earning " + _vm._s(_vm.currencyFormat(_vm.deceasedNetIncome)) + " per annum.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                There\n                " + _vm._s(_vm.getValue('dependants').length == 1 ? 'was one dependant' : 'are ') + "\n                " + _vm._s(_vm.getValue('dependants').length == 1 ? _vm.getValue('dependants').length + ' dependants' : '') + "\n                with the following income(s):\n            ")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "margin-left": "40px"
    }
  }, _vm._l((_vm.getValue('dependants')), function(item, index) {
    return _c('li', [_vm._v("\n                    Dependant " + _vm._s(index + 1) + " - " + _vm._s(_vm.currencyFormat(item.income)) + "\n                ")])
  }), 0), _vm._v(" "), _c('p', [_vm._v("\n                And the multiplicand is set at " + _vm._s(_vm.multiplicand) + "%\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                The following formula was used to calculate the dependency multiplicand:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "m-formula"
  }, [_c('div', {
    staticClass: "m-formula__item--row"
  }, [_vm._v("\n                    " + _vm._s(_vm.vueSliderFormatter(_vm.multiplicand)) + " x ([Deceased Income] + [Dependant Income]) - [Dependant Income]\n                ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3c31c37a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mini-calculators/calculators/dependencyMultiplicand.vue
// module id = 1649
// module chunks = 0